(() => {
  if (window.__dukAlgoliaDrawerInitialized) return;
  window.__dukAlgoliaDrawerInitialized = true;
  const CONFIG = {
    limits: { products: 24, collectionsRaw: 80, collectionsPerTab: 24, stores: 24 },
    timeout: 3000,
    debug: false,
    storeTab: { key: 'stores', searchTab: 'stores', label: { de: 'Geschäfte', en: 'Stores' }, showAllPath: '/search', showAllLabel: { de: 'Alle Geschäfte zeigen', en: 'Show all stores' }, layout: 'card' },
    collectionTabs: [
      { key: 'collection-series', searchTab: 'series', types: ['series'], label: { de: 'Serien', en: 'Series' }, showAllPath: '/search', showAllLabel: { de: 'Alle Serien zeigen', en: 'Show all series' }, layout: 'series-card' },
      { key: 'collection-vendor', searchTab: 'brands', types: ['vendor'], label: { de: 'Marken', en: 'Brands' }, showAllPath: '/search', showAllLabel: { de: 'Alle Marken zeigen', en: 'Show all brands' }, layout: 'card' },
      { key: 'collection-category', searchTab: 'categories', types: ['category', 'scent-family', 'type', 'primary-note', 'season'], label: { de: 'Kategorien', en: 'Categories' }, showAllPath: '/search', showAllLabel: { de: 'Alle Kategorien zeigen', en: 'Show all categories' }, layout: 'link-list' },
      { key: 'collection-note', searchTab: 'categories', types: ['note'], label: { de: 'Notes', en: 'Notes' }, showAllPath: '/search', showAllLabel: { de: 'Alle Notes zeigen', en: 'Show all notes' }, layout: 'card' },
      { key: 'collection-edit', searchTab: 'editorials', types: ['edit'], label: { de: 'Editorials', en: 'Editorials' }, showAllPath: '/search', showAllLabel: { de: 'Alle Editorials zeigen', en: 'Show all editorials' }, layout: 'card' },
      { key: 'collection-team-picks', searchTab: 'teamPicks', types: ['team-picks'], label: { de: 'Team Picks', en: 'Team Picks' }, showAllPath: '/search', showAllLabel: { de: 'Alle Team Picks zeigen', en: 'Show all team picks' }, layout: 'card' }
    ]
  };

  const nativeFetch = window.fetch.bind(window);
  let algoliaClient = null;
  const log = (...args) => CONFIG.debug && console.info('[DUK Algolia drawer]', ...args);
  const warn = (...args) => CONFIG.debug && console.warn('[DUK Algolia drawer]', ...args);

  function injectStyles() {
    if (document.getElementById('duk-algolia-drawer-styles')) return;
    const style = document.createElement('style');
    style.id = 'duk-algolia-drawer-styles';
    style.textContent = `
      .predictive-search__collection-card-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 1.5rem 1rem; }
      .predictive-search__collection-card { display: block; min-width: 0; text-decoration: none; }
      .predictive-search__collection-card-media { position: relative; overflow: hidden; aspect-ratio: 6 / 7; margin-block-end: .65rem; background: rgb(var(--border-color, 229 229 229)); }
      .predictive-search__collection-card-media img { display: block; width: 100%; height: 100%; object-fit: cover; }
      .predictive-search__collection-card .product-title { display: block; }
      .predictive-search__collection-card-info { display: grid; gap: .15rem; }
      .predictive-search__team-picks-list { display: grid; gap: .85rem; }
      .predictive-search__team-pick-result { display: flex; align-items: center; gap: .9rem; text-decoration: none; min-width: 0; }
      .predictive-search__team-pick-image { width: 4.25rem; aspect-ratio: 1; border-radius: 999px; overflow: hidden; flex: 0 0 auto; background: rgb(var(--border-color, 229 229 229)); }
      .predictive-search__team-pick-image img { display: block; width: 100%; height: 100%; object-fit: cover; }
      .predictive-search__team-pick-result .h6 { min-width: 0; }

      @media (prefers-reduced-motion: no-preference) {
        .predictive-search__products > .product-card,
        .predictive-search__collection-card-grid > .predictive-search__collection-card,
        .predictive-search__team-picks-list > .predictive-search__team-pick-result {
          animation: duk-algolia-drawer-card-reveal .18s ease-in-out both;
        }

        .predictive-search__products > :nth-child(2),
        .predictive-search__collection-card-grid > :nth-child(2),
        .predictive-search__team-picks-list > :nth-child(2) { animation-delay: .05s; }

        .predictive-search__products > :nth-child(3),
        .predictive-search__collection-card-grid > :nth-child(3),
        .predictive-search__team-picks-list > :nth-child(3) { animation-delay: .1s; }

        .predictive-search__products > :nth-child(n + 4),
        .predictive-search__collection-card-grid > :nth-child(n + 4),
        .predictive-search__team-picks-list > :nth-child(n + 4) { animation-delay: .15s; }
      }

      @keyframes duk-algolia-drawer-card-reveal {
        from { opacity: 0; transform: translateY(20px); }
        to { opacity: 1; transform: translateY(0); }
      }
    `;
    document.head.appendChild(style);
  }

  function escapeHtml(value = '') {
    return String(value).replace(/[&<>'"]/g, (char) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;' })[char]);
  }

  function normalizeValue(value) {
    if (Array.isArray(value)) return normalizeValue(value[0]);
    if (value && typeof value === 'object') return normalizeValue(value.value || value.name || value.title || value.label || '');
    return String(value || '').trim();
  }

  function getValue(object, paths, fallback = '') {
    for (const path of paths) {
      if (object && Object.prototype.hasOwnProperty.call(object, path) && object[path] !== undefined && object[path] !== null && object[path] !== '') return object[path];
      const nested = String(path).split('.').reduce((value, key) => value && value[key] !== undefined ? value[key] : undefined, object);
      if (nested !== undefined && nested !== null && nested !== '') return nested;
    }
    return fallback;
  }

  const Shared = window.DUKAlgoliaShared;
  if (!Shared) {
    console.error('[DUK Algolia drawer] shared logic is missing');
    return;
  }

  const {
    getLocaleKey,
    translate,
    localizePath,
    localizeHitUrl,
    buildIndexCandidates,
    formatProductPrice
  } = Shared;

  function getIndexCandidates(kind) {
    return buildIndexCandidates(kind);
  }

  function parseUrl(resource) {
    const url = typeof resource === 'string' ? resource : resource?.url;
    try { return url ? new URL(url, window.location.origin) : null; } catch (_error) { return null; }
  }

  function isPredictiveSearchRequest(resource) {
    const url = parseUrl(resource);
    return Boolean(url && (url.pathname.endsWith('/search') || url.pathname.endsWith('/search/')) && url.searchParams.get('section_id') === 'predictive-search' && url.searchParams.get('q')?.trim());
  }

  function getQuery(resource) { return parseUrl(resource)?.searchParams.get('q')?.trim() || ''; }
  function getCollectionType(hit) { return normalizeValue(getValue(hit, ['meta.custom.collection_type', 'metafields.custom.collection_type', 'collection_type'])); }
  function getCollectionVendor(hit) { return escapeHtml(normalizeValue(getValue(hit, ['meta.custom.vendor', 'metafields.custom.vendor', 'custom.vendor', 'vendor']))); }

  async function getAlgoliaClient() {
    if (algoliaClient) return algoliaClient;

    const startedAt = Date.now();
    while (Date.now() - startedAt < CONFIG.timeout) {
      const config = [window.algoliaShopify?.config, window.algoliaShopify, window.algoliaConfig, window.AlgoliaConfig, window.algolia, window.Algolia].filter(Boolean).find((candidate) => (candidate.app_id || candidate.application_id || candidate.appId) && (candidate.search_api_key || candidate.search_only_api_key || candidate.searchApiKey || candidate.apiKey));
      const algoliaSearch = window.algoliasearch || window.algoliaShopify?.externals?.algoliasearch;
      if (config && typeof algoliaSearch === 'function') {
        const appId = config.app_id || config.application_id || config.appId;
        const searchKey = config.search_api_key || config.search_only_api_key || config.searchApiKey || config.apiKey;
        algoliaClient = algoliaSearch(appId, searchKey);
        return algoliaClient;
      }
      await new Promise((resolve) => setTimeout(resolve, 100));
    }
    throw new Error('Algolia client/config not available');
  }

  async function searchFirstAvailableIndex(client, indexNames, query, options) {
    let lastError = null;
    for (const indexName of indexNames) {
      try {
        const result = await client.initIndex(indexName).search(query, options);
        log('searched', indexName, result?.hits?.length || 0);
        return result?.hits || [];
      } catch (error) {
        lastError = error;
        warn('index failed', indexName, error?.message || error);
      }
    }
    if (lastError) throw lastError;
    return [];
  }

  async function searchAlgolia(query) {
    const client = await getAlgoliaClient();
    const [products, collections, stores] = await Promise.all([
      searchFirstAvailableIndex(client, getIndexCandidates('products'), query, { hitsPerPage: CONFIG.limits.products + 1, clickAnalytics: true }),
      searchFirstAvailableIndex(client, getIndexCandidates('collections'), query, { hitsPerPage: CONFIG.limits.collectionsRaw, clickAnalytics: true }),
      searchFirstAvailableIndex(client, getIndexCandidates('stores'), query, { hitsPerPage: CONFIG.limits.stores + 1, clickAnalytics: true })
    ]);
    log('locale/index routing', getLocaleKey(), {
      products: getIndexCandidates('products'),
      collections: getIndexCandidates('collections'),
      stores: getIndexCandidates('stores')
    });
    log('collection types found', [...new Set(collections.map(getCollectionType).filter(Boolean))]);
    return { products, collections, stores };
  }

  function getImage(hit) {
    const image = getValue(hit, ['image', 'storefront', 'product_image', 'featured_image', 'image_url', 'thumbnail_url', 'image.src', 'featured_image.src']);
    if (Array.isArray(hit.image_urls) && hit.image_urls[0]) return hit.image_urls[0];
    if (typeof image === 'string') return image;
    return image?.src || '';
  }

  function getSizedImageUrl(imageUrl, width) {
    if (!imageUrl) return '';

    try {
      const url = new URL(imageUrl, window.location.origin);
      const isShopifyCdn = /(^|\.)cdn\.shopify\.com$/i.test(url.hostname)
        || /(^|\.)shopifycdn\.com$/i.test(url.hostname);

      if (!isShopifyCdn) return imageUrl;

      url.searchParams.set('width', String(width));
      return url.toString();
    } catch (_error) {
      return imageUrl;
    }
  }

  function renderImageAttributes(imageUrl) {
    const standardUrl = escapeHtml(getSizedImageUrl(imageUrl, 300));
    const retinaUrl = escapeHtml(getSizedImageUrl(imageUrl, 600));
    return `src="${standardUrl}" srcset="${standardUrl} 1x, ${retinaUrl} 2x" width="300"`;
  }

  function buildObjectUrl(hit, type) {
    const directUrl = getValue(hit, ['url', `${type}_url`]);
    const handle = getValue(hit, ['handle', `${type}_handle`]);
    if (!handle && !directUrl) return '#';
    const fallbackPath = type === 'page' ? `/pages/${handle}` : `/${type}s/${handle}`;
    return localizeHitUrl(directUrl, fallbackPath);
  }

  function buildStoreUrl(hit) {
    const directUrl = getValue(hit, ['url', 'store_url']);
    const handle = getValue(hit, ['handle', 'store_handle', 'objectID']);
    return directUrl || handle ? localizeHitUrl(directUrl, `/pages/stores/${handle}`) : '#';
  }


  function renderProductCard(hit, index) {
    const title = escapeHtml(getValue(hit, ['title', 'name', 'product_title']));
    const vendor = escapeHtml(getValue(hit, ['vendor', 'brand']));
    const image = getImage(hit);
    const url = escapeHtml(buildObjectUrl(hit, 'product'));
    const price = escapeHtml(formatProductPrice(hit));
    const handle = escapeHtml(getValue(hit, ['handle', 'product_handle', 'objectID']));
    const isPriorityImage = index < 4;
    const imageLoading = isPriorityImage ? 'eager' : 'lazy';
    const imagePriority = isPriorityImage ? ' fetchpriority="high"' : '';
    const imageDecoding = isPriorityImage ? 'sync' : 'async';
    return `<product-card class="product-card product-card--info-outside product-card--blends color-scheme color-scheme--scheme-1" handle="${handle}"><div class="product-card__figure"><a href="${url}" class="product-card__media">${image ? `<img ${renderImageAttributes(image)} alt="${title}" class="product-card__image product-card__image--primary aspect-natural" loading="${imageLoading}"${imagePriority} decoding="${imageDecoding}">` : ''}</a></div><div class="product-card__info product-card__info--flush"><div class="v-stack justify-items-start text-start"><div class="v-stack gap-0.5">${vendor ? `<span class="vendor text-sm">${vendor}</span>` : ''}<a href="${url}" class="product-title subheading line-clamp" style="--line-clamp-count: 2">${title}</a></div>${price ? `<price-list class="price-list"><sale-price class="subheading">${price}</sale-price></price-list>` : ''}</div></div></product-card>`;
  }

  function getCollectionTitle(hit) { return escapeHtml(getValue(hit, ['meta.custom.title_short', 'metafields.custom.title_short', 'title_short', 'title', 'name'])); }

  function renderCollectionCard(hit, options = {}) {
    const title = getCollectionTitle(hit);
    const vendor = options.showVendor ? getCollectionVendor(hit) : '';
    const image = getImage(hit);
    const url = escapeHtml(options.type === 'store' ? buildStoreUrl(hit) : buildObjectUrl(hit, 'collection'));
    const imageLoading = options.index < 4 ? 'eager' : 'lazy';
    return `<a href="${url}" class="predictive-search__collection-card group"><div class="predictive-search__collection-card-media">${image ? `<img ${renderImageAttributes(image)} alt="${title}" loading="${imageLoading}" decoding="async">` : ''}</div><div class="predictive-search__collection-card-info">${vendor ? `<span class="vendor text-sm">${vendor}</span>` : ''}<span class="product-title subheading line-clamp" style="--line-clamp-count: 2">${title}</span></div></a>`;
  }

  function renderCircleCollectionCard(hit, index) {
    const title = getCollectionTitle(hit);
    const image = getImage(hit);
    const url = escapeHtml(buildObjectUrl(hit, 'collection'));
    return `<a href="${url}" class="predictive-search__team-pick-result group"><div class="predictive-search__team-pick-image">${image ? `<img ${renderImageAttributes(image)} alt="${title}" loading="${index < 4 ? 'eager' : 'lazy'}" decoding="async">` : ''}</div><p class="h6 link-reversed">${title}</p></a>`;
  }

  function renderLinkListItem(hit, type) {
    const title = getCollectionTitle(hit);
    const url = escapeHtml(buildObjectUrl(hit, type));
    return `<li class="heading h5"><a href="${url}" class="link-reversed">${title}</a></li>`;
  }

  function renderLinkList(hits, type) {
    return `<ul class="predictive-search__link-list mega-menu__linklist unstyled-list">${hits.map((hit) => renderLinkListItem(hit, type)).join('')}</ul>`;
  }

  function renderShowAll(tabConfig, query) {
    const tabParam = tabConfig.searchTab ? `&tab=${encodeURIComponent(tabConfig.searchTab)}` : '';
    return `<div class="predictive-search__show-all"><a href="${localizePath(tabConfig.showAllPath)}?q=${encodeURIComponent(query)}${tabParam}" class="link">${translate(tabConfig.showAllLabel)}</a></div>`;
  }

  function renderStorePanel(tabConfig, hits, query, showAll) {
    const innerHtml = `<div class="predictive-search__collection-card-grid">${hits.map((hit, index) => renderCollectionCard(hit, { type: 'store', index })).join('')}</div>`;
    return `${innerHtml}${showAll ? renderShowAll(tabConfig, query) : ''}`;
  }

  function renderCollectionPanel(tabConfig, hits, query, showAll) {
    let innerHtml;
    if (tabConfig.layout === 'link-list') {
      innerHtml = renderLinkList(hits, 'collection');
    } else if (tabConfig.layout === 'circle-list') {
      innerHtml = `<div class="predictive-search__team-picks-list">${hits.map(renderCircleCollectionCard).join('')}</div>`;
    } else {
      innerHtml = `<div class="predictive-search__collection-card-grid">${hits.map((hit, index) => renderCollectionCard(hit, { showVendor: tabConfig.key === 'collection-series', index })).join('')}</div>`;
    }
    return `${innerHtml}${showAll ? renderShowAll(tabConfig, query) : ''}`;
  }

  function createTab(doc, key, label, panelHtml) {
    const button = doc.createElement('button');
    button.setAttribute('slot', 'tab');
    button.className = 'link-reversed';
    button.dataset.resultTab = key;
    button.textContent = label;
    const panel = doc.createElement('div');
    panel.setAttribute('slot', 'tabpanel');
    panel.dataset.resultPanel = key;
    panel.innerHTML = panelHtml;
    return [button, panel];
  }

  function renderNoResults(query) {
    return `<div class="predictive-search__no-results prose prose-justify-center"><p class="subheading">${translate({ de: 'Suche', en: 'Search' })}</p><p class="h5">${translate({ de: 'Keine Ergebnisse für', en: 'No results for' })} “${escapeHtml(query)}”</p></div>`;
  }

  function getResponseShell(shellHtml) {
    const doc = new DOMParser().parseFromString(shellHtml || '', 'text/html');
    let tabs = doc.querySelector('x-tabs.search-tabs');
    let section = tabs ? tabs.closest('.shopify-section') : doc.querySelector('.shopify-section');

    if (!section) {
      section = doc.createElement('div');
      section.className = 'shopify-section';
      doc.body.replaceChildren(section);
      if (tabs) section.appendChild(tabs);
    }

    if (!tabs) {
      tabs = doc.createElement('x-tabs');
      tabs.className = 'search-tabs';
      tabs.setAttribute('data-algolia-search-shell', '');
      section.replaceChildren(tabs);
    }

    return { doc, section, tabs };
  }

  function buildNoResultsResponseHtml(shellHtml, query) {
    const { doc, section } = getResponseShell(shellHtml);
    section.innerHTML = renderNoResults(query);
    return doc.body.innerHTML;
  }

  function buildResponseHtml(shellHtml, results, query) {
    const { doc, section, tabs } = getResponseShell(shellHtml);
    const nodes = [];
    const visibleProducts = results.products.slice(0, CONFIG.limits.products);
    if (visibleProducts.length) {
      const showAllProducts = results.products.length > CONFIG.limits.products;
      nodes.push(createTab(doc, 'products', translate({ de: 'Produkte', en: 'Products' }), `<div class="predictive-search__products">${visibleProducts.map(renderProductCard).join('')}</div>${showAllProducts ? `<div class="predictive-search__show-all"><a href="${localizePath('/search')}?q=${encodeURIComponent(query)}&type=product&options%5Bprefix%5D=last&tab=products" class="predictive-search-link">${translate({ de: 'Alle Produkte anzeigen', en: 'Show all products' })}</a></div>` : ''}`));
    }
    for (const tabConfig of CONFIG.collectionTabs) {
      const matchingHits = results.collections.filter((hit) => tabConfig.types.includes(getCollectionType(hit)));
      const hits = matchingHits.slice(0, CONFIG.limits.collectionsPerTab);
      if (!hits.length) continue;
      nodes.push(createTab(doc, tabConfig.key, translate(tabConfig.label), renderCollectionPanel(tabConfig, hits, query, matchingHits.length > CONFIG.limits.collectionsPerTab)));
    }
    const visibleStores = results.stores.slice(0, CONFIG.limits.stores);
    if (visibleStores.length) {
      nodes.push(createTab(doc, 'stores', translate(CONFIG.storeTab.label), renderStorePanel(CONFIG.storeTab, visibleStores, query, results.stores.length > CONFIG.limits.stores)));
    }
    if (!nodes.length) {
      section.innerHTML = renderNoResults(query);
      return doc.body.innerHTML;
    }
    tabs.innerHTML = '';
    nodes.flat().forEach((node) => tabs.appendChild(node));
    return doc.body.innerHTML;
  }

  window.fetch = async function algoliaOnlyPredictiveSearchFetch(resource, options) {
    const response = await nativeFetch(resource, options);
    if (!isPredictiveSearchRequest(resource)) return response;
    const query = getQuery(resource);
    const shellHtml = await response.clone().text();
    try {
      injectStyles();
      const results = await searchAlgolia(query);
      return new Response(buildResponseHtml(shellHtml, results, query), { status: 200, headers: { 'content-type': 'text/html; charset=utf-8' } });
    } catch (error) {
      warn('Algolia predictive search failed; using Shopify response', error?.message || error);
      return response;
    }
  };

  injectStyles();
  log('Algolia-only drawer loaded', getLocaleKey());
})();
